/**
 * ****************************************************************************
 * @description     :   MainHeader
 * @created at      :   2022/07/13
 * @created by      :   
 * @package         :   dailyreportsystem
 * @copyright       :   Copyright (c)
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

/**
 * Import for redux
 */
import Actions from "../redux/app/actions";

/**
 * Import child components
 */
// import LeftHeader from "./left-header";
import RightHeader from "./right-header";

/**
 * The header of template
 * -----------------------------------------
 * @author : create
 * @param  : {Object} props - Properties of this component
 * @access : public
 */
const MainHeader = (props) => {
    const dispatch = useDispatch();
    const { chats, notify } = props;
    
    /**
     * Open or close sidebar menu when user click button toggle menu
     * -----------------------------------------
     * @author : create
     * @access : private
     */
    const toggleMobileMenu = function () {
        dispatch(Actions.ToggleMenuMobile());
    };
    return (
        <div className="nk-header nk-header-fixed is-light">
            <div className="container-fluid">
                <div className="nk-header-wrap">
                    <div className="toggle_mobile_sidebar nk-menu-trigger d-xl-none ml-n1">
                        <a
                            href="javascript:void(0);"
                            className="toggle_mobile_sidebar nk-nav-toggle nk-quick-nav-icon"
                            data-target="sidebarMenu"
                            onClick={toggleMobileMenu.bind(this)}
                        >
                            <em className="toggle_mobile_sidebar icon ni ni-menu" />
                        </a>
                    </div>
                    
                    
                    <RightHeader chats={chats} notify={notify} />
                </div>
            </div>
        </div>
    );
};

MainHeader.propTypes = {
    /**
     * Show menu in left of header or not
     */
    // showLeftHeader: PropTypes.bool,
    /**
     * Data of information will show on left header
     */
    dataTitle: PropTypes.shape({
        /**
         * Icon of screen is dislaying
         */
        icon: PropTypes.string,
        /**
         * Title of screen is dislaying
         */
        subText: PropTypes.string,
        /**
         * Child title of screen is dislaying
         */
        leadText: PropTypes.string
    })
};

MainHeader.defaultProps = {
    // showLeftHeader: true,
    dataTitle: {
        icon: 'ni-dashlite bg-purple-dim',
        subText: 'DashLite',
        leadText: 'Dashboard'
    }
};

export default React.memo(MainHeader);
